'use strict';exports.__esModule = true;exports.askForeignLimit = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;
var askForeignLimit = (0, _reduxAct.createAction)('/ASK_FOREIGN_LIMIT');
var askForeignLimitSuccess = (0, _reduxAct.createAction)('/ASK_FOREIGN_LIMIT_SUCCESS');
var askForeignLimitFail = (0, _reduxAct.createAction)('/ASK_FOREIGN_LIMIT_FAIL');

var initialState = {
  loaded: false,
  loading: false,
  data: {} };


var fetchAskForeignLimit = function fetchAskForeignLimit(_ref) {var data = _ref.data;return (
    _axios2.default.post('users/ask-foreign-limit-change', data).
    then(askForeignLimitSuccess, askForeignLimitFail));};

var handleAskForeignLimit = function handleAskForeignLimit(state, data) {return (
    (0, _reduxLoop.loop)(Object.assign({}, state, { error: null, loaded: false, loading: true }), promise(fetchAskForeignLimit, data)));};

var handleAskForeignLimitSuccess = function handleAskForeignLimitSuccess(state, _ref2) {var data = _ref2.data;return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: data });};


var handleAskForeignLimitFail = function handleAskForeignLimitFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: {},
    error: error });

};


var foreignLimit = (0, _reduxAct.createReducer)(function (on) {
  on(askForeignLimit, handleAskForeignLimit);
  on(askForeignLimitSuccess, handleAskForeignLimitSuccess);
  on(askForeignLimitFail, handleAskForeignLimitFail);
}, initialState);exports.

askForeignLimit = askForeignLimit;exports.default =

foreignLimit;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/feedbackIncreaseLimits.js
// module id = 1275
// module chunks = 0